import { render, staticRenderFns } from "./BackupDatabase.vue?vue&type=template&id=1aae7892"
import script from "./BackupDatabase.vue?vue&type=script&lang=js"
export * from "./BackupDatabase.vue?vue&type=script&lang=js"
import style0 from "./BackupDatabase.vue?vue&type=style&index=0&id=1aae7892&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports